import { Component } from '@angular/core';

@Component({
    selector: 'quiz-game',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class QuizGameComponent {}
